import { render } from "./PackageDiscountFormModal.vue?vue&type=template&id=32afa455&scoped=true"
import script from "./PackageDiscountFormModal.vue?vue&type=script&lang=js"
export * from "./PackageDiscountFormModal.vue?vue&type=script&lang=js"

import "./PackageDiscountFormModal.vue?vue&type=style&index=0&id=32afa455&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32afa455"]])

export default __exports__